module.exports = __webpack_public_path__ + "static/media/mapSubwayRight.f95a7515.png";